module.exports = __webpack_public_path__ + "img/areas.a31d3cd1.png";